import { DRAG_LOOP_MS } from "constants/constants";
import { selectMeAdmin } from "slices/spaceMediaSlice";
import {
  leaveSpace,
  kickFromSpace,
  turnOffFocus,
  turnOnPreFocus,
} from "slices/spaceSlice";
import { greyOutAll, ungreyOutAll } from "./spaceDraws";
import { calcAllD2M, resetAllMedia } from "./spaceMediaPhysics";
import { sendMyMove, signalSendOtherMove } from "./spaceSignalling";
import { sentFPS, setsentFPS } from "./spaceTest";
import {
  iAmLocked,
  myCircle,
  myLuid,
  people,
  SPACEBOX,
  spaceBoxHeight,
  spaceBoxWidth,
  edgeBuffer,
  fontHeight,
} from "./spaceVars";
// let dispatch = null;
let getState = null;
import("Store").then((module) => {
  // dispatch = module.store.dispatch;
  getState = module.store.getState;
});

var dragLoop = null;
var iMoved = false;
var elseMoved = false;
export const setiMoved = (val) => (iMoved = val);

export var dragActive = false;
var dragOtherActive = false;
var fadedClone = null;
var fadedLuid = null;
var initialX;
var initialY;

export var xOffset = 0; // For dragging continuity
export function setXOffset(val) {
  xOffset = val;
}
export var yOffset = 0; // For dragging continuity
export function setYOffset(val) {
  yOffset = val;
}
export var looping = false;

export function resetDragging() {
  dragActive = false;
  xOffset = 0;
  yOffset = 0;
  looping = false;
}

SPACEBOX.addEventListener("touchstart", dragStart, false);
SPACEBOX.addEventListener("touchend", dragEnd, false);
SPACEBOX.addEventListener("touchmove", drag, false);

SPACEBOX.addEventListener("mousedown", dragStart, false);
SPACEBOX.addEventListener("mouseup", dragEnd, false);

SPACEBOX.addEventListener("mousemove", drag, false);
SPACEBOX.addEventListener("mouseleave", dragEnd, false);

// e.client is the coordinates from the top left of the page
// x&y offsets are the coordinates from the top left of the SPACEBOX
// initialX&Y are the difference between the absolute coordinates to the SPACEBOX coordinates because when we get the e.client coords again we'll need to find the difference

function dragStart(e) {
  if (e.target === myCircle) {
    if (iAmLocked) return;
    if (e.type === "touchstart") {
      initialX = e.touches[0].clientX - xOffset;
      initialY = e.touches[0].clientY - yOffset;
    } else {
      initialX = e.clientX - xOffset;
      initialY = e.clientY - yOffset;
    }
    dragActive = true;
    startDragLoop();
    greyOutAll();
    turnOnPreFocus();
    turnOffFocus();
    calcAllD2M();
  } else if (e.target.classList?.contains("remoteCircle")) {
    if (selectMeAdmin(getState())) {
      fadedClone = e.target.cloneNode(true);
      fadedLuid = fadedClone.id;
      fadedClone.id = "f" + fadedLuid;
      fadedClone.classList.add("moving-other");

      dragOtherActive = true;
      startDragLoop();
      xOffset = people[fadedLuid].x;
      yOffset = people[fadedLuid].y;

      if (e.type === "touchstart") {
        initialX = e.touches[0].clientX - xOffset;
        initialY = e.touches[0].clientY - yOffset;
      } else {
        initialX = e.clientX - xOffset;
        initialY = e.clientY - yOffset;
      }
    }
    // To stop focus remaining
    e.preventDefault();
  }
}

function dragEnd(e) {
  if ((!dragActive || iAmLocked) && !dragOtherActive) return;

  if (dragOtherActive) {
    if (SPACEBOX.querySelector(".doorway").classList.contains("drag-active")) {
      kickFromSpace(fadedLuid.toString());
    } else signalSendOtherMove(xOffset, yOffset, fadedLuid);
    fadedClone.remove();
    fadedClone = null;
    fadedLuid = null;
    xOffset = people[myLuid].x;
    yOffset = people[myLuid].y;
  }
  if (!SPACEBOX.querySelector(".doorway").classList.contains("drag-active")) {
    moveIfColliding();
  }
  stopDragLoop();
  if (Object.keys(people).length > 0) calcAllD2M();
  ungreyOutAll();
  resetPostDrag();

  if (SPACEBOX.querySelector(".doorway").classList.contains("drag-active")) {
    SPACEBOX.querySelector(".doorway").classList.remove("drag-active");
    SPACEBOX.querySelector(".doormat").classList.remove("drag-active");
    if (dragActive) leaveSpace();
  }

  dragActive = false;
  dragOtherActive = false;
}
export function resetPostDrag() {
  resetAllMedia();
  initialX = xOffset;
  initialY = yOffset;
}

function preventOverflowX(x) {
  if (x < 0) return 0;
  if (x > spaceBoxWidth - edgeBuffer) return spaceBoxWidth - edgeBuffer;
  return x;
}

function preventOverflowY(y) {
  if (y < 0) return 0;
  if (y > spaceBoxHeight - edgeBuffer) return spaceBoxHeight - edgeBuffer;
  return y;
}

function drag(e) {
  if ((!dragActive || iAmLocked) && !dragOtherActive) return;
  e.preventDefault();

  if (e.type === "touchmove") {
    xOffset = preventOverflowX(e.touches[0].clientX - initialX);
    yOffset = preventOverflowY(e.touches[0].clientY - initialY);
  } else {
    xOffset = preventOverflowX(e.clientX - initialX);
    yOffset = preventOverflowY(e.clientY - initialY);
  }

  if (dragActive) {
    setTranslateAndCalc(xOffset, yOffset, myCircle);
    iMoved = true;
  } else if (dragOtherActive) {
    elseMoved = true;
    if (!SPACEBOX.contains(fadedClone)) {
      SPACEBOX.appendChild(fadedClone);
    }
    setTranslateFaded(xOffset, yOffset);
  }
}

export function setTranslateAndCalc(x, y, personCircle) {
  personCircle.style.transform = "translate3d(" + x + "px, " + y + "px, 0)";
  people[myLuid].x = x;
  people[myLuid].y = y;
}

function setTranslateFaded(x, y) {
  fadedClone.style.transform =
    "translate3d(" + x + "px, " + y + "px, 0) scale(1.2)";
}

export function moveIfColliding(alwaysSendMove = false, repelFactor = 1) {
  if (!people[myLuid]) return;
  window.efs_debug && window.log("MOVE IF COLLIDING");

  let currentX = people[myLuid].x;
  let currentY = people[myLuid].y;

  // Determine Position to move in pixels
  // don't collide with people and walls
  // forcedMove
  if (!collides(currentX, currentY, repelFactor)) {
    if (alwaysSendMove) sendMyMove(currentX, currentY);
    return;
  }
  let newX = currentX;
  let newY = currentY;

  window.efs_debug && window.log("WE ARE COLLIDING");
  // Yes this is JS :o
  loop: for (let d = 0; d < spaceBoxWidth; d = d + 0.5) {
    for (let angle = 0; angle < 360; angle++) {
      if (
        !collides(
          currentX + d * Math.sin(angle),
          currentY + d * Math.cos(angle),
          repelFactor
        )
      ) {
        newX = currentX + d * Math.sin(angle);
        newY = currentY + d * Math.cos(angle);
        break loop;
      }
    }
  }

  forcedMove(newX, newY);
  sendMyMove(newX, newY);
}

function collides(myX, myY, repelFactor) {
  // Test SPACEBOX boundaries
  // * 2 so as to push em further away from door
  if (withinExitRange(myX / 1.6, myY / 1.6)) {
    return true;
  }
  if (
    myY < 0 ||
    myY > spaceBoxHeight - edgeBuffer ||
    myX < 0 ||
    myX > spaceBoxWidth - edgeBuffer
  )
    return true;
  // Test Closeness to others
  for (let luid in people) {
    if (luid !== myLuid) {
      if (
        Math.sqrt(
          Math.pow(myX - people[luid].x, 2) + Math.pow(myY - people[luid].y, 2)
        ) <
        edgeBuffer * repelFactor
      )
        return true;
    }
  }
  return false;
}

export function forcedMove(xPx, yPx) {
  setXOffset(xPx);
  setYOffset(yPx);
  myCircle.classList.add("moving-by-other");
  setTranslateAndCalc(xPx, yPx, myCircle);
  calcAllD2M();
  resetPostDrag();
  setTimeout(() => {
    if (myCircle) myCircle.classList.remove("moving-by-other");
  }, 200);
  moveIfColliding();
}

export function startDragLoop() {
  window.efs_debug && window.log("START DRAG");
  dragLoop = setInterval(dragAction, DRAG_LOOP_MS);
}
function dragAction() {
  if (withinExitRange(xOffset, yOffset)) {
    SPACEBOX.querySelector(".doorway").classList.add("drag-active");
    SPACEBOX.querySelector(".doormat").classList.add("drag-active");
  } else {
    SPACEBOX.querySelector(".doorway").classList.remove("drag-active");
    SPACEBOX.querySelector(".doormat").classList.remove("drag-active");
  }

  if (iMoved) {
    iMoved = false;
    calcAllD2M();
    setsentFPS(sentFPS + 1);
    sendMyMove(people[myLuid].x, people[myLuid].y);
  } else if (elseMoved) {
    elseMoved = false;
  }
}
const withinExitRange = (x, y) =>
  Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)) < fontHeight * 2.8;

export function stopDragLoop() {
  window.efs_debug && window.log("STOP DRAG");
  dragAction();
  clearInterval(dragLoop);
}
